import '../assets/js/main.js';
import $ from 'jquery';
import React, { useEffect, useState } from 'react';
import { NavLink } from "react-router-dom";
import { useLocation } from 'react-router-dom';

const Navbar = () => {
    const location = useLocation();

    const [theme, setTheme] = useState(
        localStorage.getItem('theme') || 'light'
    );

    const toggleTheme = () => {
        if (theme === 'light') {
            setTheme('dark');
            $(".toggle-theme i").addClass("fa-sun");
            $(".toggle-theme i").removeClass("fa-moon");
        } else {
            setTheme('light');
            $(".toggle-theme i").addClass("fa-moon");
            $(".toggle-theme i").removeClass("fa-sun");
        }
    };
    useEffect(() => {
        localStorage.setItem('theme', theme);
        document.body.className = theme;
    }, [theme]);

    window.addEventListener('load', (event) => {
        $(".preloader").fadeOut("slow");
    });

    return (
        <>
            <header>
                <NavLink className="logo" to="/">Drop<jk>soon</jk></NavLink>
                <nav>
                    <ul className="nav__links">
                        <li><NavLink to="/" isActive={(match, location) => {
                            return location.pathname === "/";
                        }}>Dropy</NavLink></li>
                        <li><NavLink to="/sale" isActive={(match, location) => {
                            return location.pathname === "/sale";
                        }}>Wyprzedaż</NavLink></li>
                        <li><NavLink to="/raffles" isActive={(match, location) => {
                            return location.pathname === "/raffles";
                        }}>Losowania</NavLink></li>
                        <li><NavLink to="/news" isActive={(match, location) => {
                            return location.pathname === "/news";
                        }}>Nowości</NavLink></li>
                        <li><a className="toggle-theme" onClick={toggleTheme}><i className="fa-solid fa-sun"></i></a></li>
                    </ul>
                </nav>
            </header>
            <div className="navigation">
                <ul>
                    <li className={location.pathname === '/' ? 'list active' : 'list'} currentPage='home'>
                        <NavLink to="/">
                            <span className="icon"><i className="fa-solid fa-gift"></i></span>
                            <span className="text">Dropy</span>
                        </NavLink>
                    </li>
                    <li className={location.pathname === '/sale' ? 'list active' : 'list'}>
                        <NavLink to="/sale">
                            <span className="icon"><i className="fa-solid fa-percent"></i></span>
                            <span className="text">Wyprzedaż</span>
                        </NavLink>
                    </li>
                    <li className={location.pathname === '/raffles' ? 'list active' : 'list'}>
                        <NavLink to="/raffles">
                            <span className="icon"><i className="fa-solid fa-shuffle"></i></span>
                            <span className="text">Losowania</span>
                        </NavLink>
                    </li>
                    <li className={location.pathname === '/news' ? 'list active' : 'list'}>
                        <NavLink to="/news">
                            <span className="icon"><i className="fa-solid fa-newspaper"></i></span>
                            <span className="text">Nowości</span>
                        </NavLink>
                    </li>
                    <li className="lista">
                        <a className="toggle-theme" onClick={toggleTheme}>
                            <span className="icon"><i className="fa-regular fa-sun"></i></span>
                            <span className="text">Motyw</span>
                        </a>
                    </li>
                    {location.pathname === '/' || location.pathname === '/sale' || location.pathname === '/raffles' || location.pathname === '/news' ?
                        <div className="indicator"></div> : null}
                </ul>
            </div>
        </>
    );
};

export default Navbar;